import React, { useEffect } from 'react';

const ADS_CLIENT = process.env.REACT_APP_ADSENSE_CLIENT_ID || '';
const ADS_SLOT = process.env.REACT_APP_ADSENSE_SLOT_MAIN || '';

function AdBanner() {
  useEffect(() => {
    if (!ADS_CLIENT || !ADS_SLOT) return;
    if (typeof window === 'undefined') return;

    const existing = document.querySelector(`script[data-ads-client="${ADS_CLIENT}"]`);
    if (!existing) {
      const script = document.createElement('script');
      script.async = true;
      script.src = `https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=${ADS_CLIENT}`;
      script.crossOrigin = 'anonymous';
      script.dataset.adsClient = ADS_CLIENT;
      document.head.appendChild(script);
    }
  }, []);

  useEffect(() => {
    if (!ADS_CLIENT || !ADS_SLOT) return;
    if (typeof window === 'undefined') return;

    try {
      // eslint-disable-next-line no-undef
      (window.adsbygoogle = window.adsbygoogle || []).push({});
    } catch (_) {
      // script may not be ready yet
    }
  }, []);

  if (!ADS_CLIENT || !ADS_SLOT) return null;

  return (
    <div className="ad-container" aria-label="Publicidad">
      <ins
        className="adsbygoogle"
        style={{ display: 'block' }}
        data-ad-client={ADS_CLIENT}
        data-ad-slot={ADS_SLOT}
        data-ad-format="auto"
        data-full-width-responsive="true"
      />
    </div>
  );
}

export default AdBanner;
